import React, {useEffect, useState} from 'react'
import {getAllRole, getCalloutQueue, getExtensions, searchTenant, searchUser} from "../../../services/api/apiUser"
import UserProvider from "./UserProvider"
import {message, Pagination} from "antd"
import UserTable from "./datas/UserTable"
import UseDebounce from "../../shared/UseDebounce"
import UserFilters from "./filters/UserFilters"
import {convertTreeUser} from "../../../helpers/formatTree"
import {getDepartment} from "../../../services/api/apiDepartment"
import AddUserButton from "./shared/AddUserButton"
import parseToken from "../../../helpers/parseToken"
import checkRole from "../../../helpers/checkRole";
import CalloutAssign from "./actions/CalloutAssign";
import UserForm from "./shared/UserForm"

function UserPage() {
    const decodeToken = parseToken()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [userName, setUserName] = useState('')
    const [fullName, setFullName] = useState('')
    const [deptId, setDeptId] = useState('')
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [listUsers, setListUsers] = useState([])
    const [total, setTotal] = useState(0)
    const [showFilter, setShowFilter] = useState(false)
    const [listDepartment, setListDepartment] = useState([])
    const [roles, setRoles] = useState([])
    const [tenants, setTenants] = useState([])
    const [extensions, setExtensions] = useState([])
    const [selectAll, setSelectAll] = useState(false)
    const [arrSelected, setArrSelected] = useState([])
    const [listCalloutId, setListCalloutId] = useState([{name: "All", value: ""}])
    const [dataSelect, setDataSelect] = useState({})
    const [showEdit, setShowEdit] = useState(false)

    const _onShowEdit = (dataItem) => {
        setShowEdit(true)
        setDataSelect(dataItem)
    }

    const _onHiddenEdit = () => {
        setShowEdit(false)
        setDataSelect({})
    }

    const _onToggleFilter = () => {
        setShowFilter(!showFilter)
    }

    const _handleChangeInput = (e) => {
        const {name, value} = e.target

        if (name === 'userName') {
            setUserName(value)
            setPage(1)
        } else {
            setFullName(value)
            setPage(1)
        }
    }

    const _onChangeDepartment = (value) => {
        setDeptId(value)
    }

    const _onChangeLimit = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const _fetchListDepartment = async () => {
        try {
            const response = await getDepartment({}, decodeToken.sub)

            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            setListDepartment(data)
        } catch (e) {
            message.error(e.message)
        }
    }

    const _fetchListUser = async () => {
        setLoading(true)
        setError('')
        setListUsers([])

        try {
            const payload = {
                userName,
                fullName,
                deptId,
                page,
                limit
            }
            const response = await searchUser(payload, decodeToken.sub)

            const {success, data, error_message, totalRecord} = response

            if (parseInt(success) !== 1) {
                setLoading(false)

                return setError(error_message)
            }

            setLoading(false)
            setListUsers(data)
            setTotal(totalRecord)
        } catch (e) {
            return {
                loading: false,
                error: e.message
            }
        }
    }

    const _fetchListRole = async () => {
        try {
            const response = await getAllRole({}, decodeToken.sub)

            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            setRoles(data)
        } catch (e) {
            message.error(e.message)
        }
    }

    const _fetchListTenant = async () => {
        try {
            const payload = {
                page: 1,
                limit: 10000
            }
            const response = await searchTenant(payload, decodeToken.sub)
            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            setTenants(data)
        } catch (e) {
            message.error(e.message)
        }
    }

    const _fetchListExtensions = async () => {
        try {
            const payload = {
                page: 1,
                limit: 10000
            }
            const response = await getExtensions(payload, decodeToken.sub)
            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            setExtensions(data)
        } catch (e) {
            message.error(e.message)
        }
    }

    function itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a href={() => false}>Previous</a>
        }
        if (type === 'next') {
            return <a href={() => false}>Next</a>
        }
        return originalElement
    }

    const _handleCheckALl = (isChecked) => {
        if (isChecked) {
            const selectedLead = listUsers.map(itemL => itemL.userId)
            setArrSelected(selectedLead)
            setSelectAll(true)
        } else {
            setArrSelected([])
            setSelectAll(false)
        }
    }

    const _handleClearChecked = () => {
        setArrSelected([])
        setSelectAll(false)
    }

    const _updateSelected = (id, isAdded) => {
        if (isAdded && !arrSelected.includes(id)) {
            setArrSelected([...arrSelected, id])
            setSelectAll(arrSelected.length + 1 === listUsers.length)
        } else {
            const filtered = arrSelected.filter(item => item !== id)
            setArrSelected(filtered)
            setSelectAll(false)
        }
    }

    const _fetchListCallout = async () => {
        try {
            const response = await getCalloutQueue({}, decodeToken.sub)

            const {success, data, error_message} = response
            if (parseInt(success) !== 1) {
                setLoading(false)
                message.error(error_message)
                return
            }

            const _listCall = data.map(item => {
                return {
                    name: item.calloutQueue + ' - ' + item.calloutNumber,
                    value: item.calloutId
                }
            })
            setLoading(false)
            setListCalloutId([{name: "All", value: ""}, ..._listCall])
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const debouncedSearchUserName = UseDebounce(userName, 1000)
    const debouncedSearchFullName = UseDebounce(fullName, 1000)

    useEffect(() => {
        _fetchListDepartment()
        _fetchListRole()
        _fetchListTenant()
        _fetchListExtensions()
        _fetchListCallout()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        _fetchListUser()
        // eslint-disable-next-line
    }, [debouncedSearchUserName, debouncedSearchFullName, deptId, limit, page])

    const treeData = convertTreeUser(listDepartment)

    return (
        <UserProvider
            getUsers={_fetchListUser}
            treeData={treeData}
            listDepartment={listDepartment}
            roles={roles}
            tenants={tenants}
            extensions={extensions}
            listCalloutId={listCalloutId}
            getExtensions={_fetchListExtensions}
        >
            <div className="UserPage PageDefault CustomersPage">
                <div className='PageHeading'>
                    <h1 className="PageTitle">User Manager</h1>
                    <div className="PageFilterTop">
                        <div className="FiltersOpen" onClick={_onToggleFilter}>
                            <span className="material-icons Filter">filter_list</span>
                            <label>Bộ lọc</label>
                        </div>

                        {
                            checkRole('call.calloutAssign') && arrSelected.length > 0 && <CalloutAssign
                                usersSelected={arrSelected}
                                getUsers={_fetchListUser}
                                listUsers={listUsers}
                                onClearChecked={_handleClearChecked}
                            />
                        }

                        <AddUserButton/>
                    </div>
                </div>

                {
                    showFilter && <div className="Filter">
                        <UserFilters
                            userName={userName}
                            fullName={fullName}
                            deptId={deptId}
                            treeData={treeData}
                            onChangeDepartment={_onChangeDepartment}
                            onChangeInput={_handleChangeInput}
                        />
                    </div>
                }

                <div className="ContentPage">
                    <UserTable
                        loading={loading}
                        error={error}
                        listUsers={listUsers}
                        selectAll={selectAll}
                        arrSelected={arrSelected}
                        onCheckALl={_handleCheckALl}
                        onSelected={_updateSelected}
                        onShowEdit={_onShowEdit}
                    />

                    <div className="FooterTable">
                        <div className="Total">Show all {listUsers.length} items</div>
                        <Pagination
                            className="PaginationCustom"
                            showSizeChanger={false}
                            total={total}
                            current={page}
                            pageSize={limit}
                            itemRender={itemRender}
                            onChange={_onChangeLimit}
                        />
                    </div>
                </div>
            </div>

            {
                showEdit &&
                <UserForm label={'Sửa thông tin user'} type={'edit'} showEdit={showEdit} onHiddenEdit={_onHiddenEdit}
                          item={dataSelect}/>
            }
        </UserProvider>
    )
}

export default UserPage
